import t from "@/lang/lang";
import { Trash2 } from "lucide-react";
import { Building } from "@/services/backend/buildings/types/building";
import { Button } from "@/shared/components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/shared/components/ui/alert-dialog";

export function DeleteBuildingButton({
  building,
  onDeleteBuilding,
  variant = "icon",
}: {
  building: Building;
  onDeleteBuilding: (buildingId: string) => void;
  variant?: "icon" | "button";
}) {
  const hasNestedData = building.levels.length > 0 || building.areas.length > 0;

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        {variant === "button" ? (
          <Button variant="destructive">
            <Trash2 className="mr-2 h-4 w-4" />
            {t("Gebäude löschen")}
          </Button>
        ) : (
          <Button variant="ghost" size="icon" className="text-destructive">
            <Trash2 className="h-4 w-4" />
          </Button>
        )}
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("Gebäude löschen?")}</AlertDialogTitle>
          <AlertDialogDescription>
            {hasNestedData
              ? t(
                  `Das Gebäude (${building.name}) enthält Ebenen oder Bereiche. Beim Löschen werden alle enthaltenen Daten mitgelöscht.`,
                )
              : t(
                  `Möchten Sie das Gebäude (${building.name}) unwiderruflich löschen?`,
                )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("Abbruch")}</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => onDeleteBuilding(building.id)}
            className="bg-destructive hover:bg-destructive/90"
          >
            {t("Löschen")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
